export const ODESSA_URL = "https://webapisegupoliza.odessaseguros.com";

export const PRODUCT_TYPE_VEHICLE = 1;
export const PRODUCT_TYPE_FUNERAL = 2;
export const PRODUCT_TYPE_LIFE = 3;

export var productTypeLabels = {};
productTypeLabels[PRODUCT_TYPE_VEHICLE] = "Auto";
productTypeLabels[PRODUCT_TYPE_FUNERAL] = "Gastos funerarios";
productTypeLabels[PRODUCT_TYPE_LIFE] = "Vida";